export default __webpack_public_path__ + "static/media/seller_m.98560777.png";